import { Children, isValidElement } from 'react'

//biome-ignore lint/suspicious/noExplicitAny: <explanation>
type Child = React.JSXElementConstructor<any>

export type IValidChildComponents = {
  /**
   * Representa o filho que pode ser renderizado
   */
  child: Child
  /**
   * Representa a quantidade de vezes que esse componente pode ser renderizado
   */
  amount: number
}

/**
 *
 * @param children Filhos do componente a ser validado
 * @param validComponents Array com os componentes que podem serem realizados
 * @returns filhos validos
 */
export const renderCompositionChildren = (
  children: React.ReactNode,
  validComponents: IValidChildComponents[]
) => {
  const childrenArray = Children.toArray(children)?.filter(child =>
    isValidElement(child)
  )

  return childrenArray.map((child, index) => {
    const validComponent = validComponents.find(
      component => child.type === component.child
    )

    // Representa quantos items válidos tem antes do index desse componente
    const childAmount = childrenArray.reduce<number>((acc, c, cIndex) => {
      if (c?.type === child.type && cIndex <= index) {
        return acc + 1
      }

      return acc
    }, 0)

    /**
     * Se o child for um component valido e estiver antes da quantidade
     * permitida, deve ser renderizado.
     */
    if (validComponent && childAmount <= validComponent?.amount) return child

    return null
  })
}
